import $ from 'jquery';
import { revieveTryOn } from '../../modules/revieve-try-on';
import { renderPlpSocialProof } from '../../modules/social-proof';
import { logEngagement, logEngagementWithDetails } from "../../modules/global/log-engagement";
import { sizeSelection } from './size-selection';
import { resetSidePanel } from '../../modules/side-panel-init';

export const SELECTORS = {
  sortBy : '#sortby',
  clearFilter: '#clear_filters',
  applyFilter: '#apply_filters',
  filterClickable: '.plp-filter-clickable',
  catFilter : '#category',
  departmentFilter: '#department',
  checkboxFilter: '.js-checkbox-filter',
  sidebarClose: '.js-side-panel-close',
  refineButton: '#refineBtn',
  sortRefineButton: '#sortRefineBtn', // AB test, misnomer since now only refine but not changing to reduce regressions
  plpNavDropdown: '#plpNavDropdown',
};

var addtionalFilterArray = ['benefits', 'benefits_hair', 'coverage', 'finish', 'skin_type', 'key_ingredient', 'formulation',
    'frame_type', 'lens_detail', 'face_shape', 'sunglasses_fit', 'stretch'];
const filterNames = ['designer', 'category', 'size', 'color', 'price', 'heel', 'length', 'sleeve', 'rise', 'fragrance',
    'length_rise',
    'benefits', 'benefits_hair', 'coverage', 'finish', 'skin_type', 'key_ingredient', 'formulation',
    'frame_type', 'lens_detail', 'face_shape', 'sunglasses_fit', 'stretch', 'sustainability', 'condition']; // including addtionalFilterArray
// Map the filter names to the URL parameter names to the JS object keys
const filterNamesToUrlParamsMap = {
    designer: 'designers',
    size: 'sizes',
    color: 'colors',
    price: 'prices',
    heel: 'heels',
    length: 'lengths',
    sleeve: 'sleeves',
    rise: 'rises',
    fragrance: 'fragrances',
    condition: 'conditions',
}
const checkboxFilterNamesToForceFalseValue = ['in_stock', 'preorder'];
const checkboxFilterNames = ['sustainability'].concat(checkboxFilterNamesToForceFalseValue);

// Having these names in a JS object makes lookups faster than a nested loop
const checkboxFiltersForcedFalseObj = checkboxFilterNamesToForceFalseValue.reduce((result, item, index) => {
    result[item] = true;
    return result;
}, {});
const filtersAppliedDelimiter = '-';
const filtersParamName = 'filters';
var atStartRegex = new RegExp('^' + filtersAppliedDelimiter);
var doubleRegex = new RegExp(filtersAppliedDelimiter + filtersAppliedDelimiter);
var atEndRegex = new RegExp(filtersAppliedDelimiter + '$');

const REFINE_MENU_MODULE = 'Refine Dropdown';
const SMART_FILTER_PARAM = 'sf';
const DELIMITER = "-";

$(function() {
    window.onpopstate = function(event) {
        var updatedNewURl = location.href + location.search;
        let visualNavPageNum = 1;
        if(typeof window.getVisualNavPageNumFromUrl == "function"){
            visualNavPageNum = window.getVisualNavPageNumFromUrl();
        }
        if (window.rcProps.isSmartFiltersPage) {
            const selectedFilters = new Set();
            const searchParams = new URLSearchParams(location.search);
            searchParams.forEach((value, key) => {
                if (key === SMART_FILTER_PARAM) {
                    selectedFilters.add(value);
                }
            });

            const $filters = $('#smart-filters-form input[type="checkbox"]');
            $filters.prop('disabled', false).prop('checked', false).each(function () {
                const $this = $(this);

                if (selectedFilters.has(`${$this.prop('name')}${DELIMITER}${$this.prop('value')}`)) {
                    $this.prop('checked', true);
                }
            });
            updateValidSmartFilters();
            updateSmartFiltersCount();
        }
        updateContent(updatedNewURl, visualNavPageNum);
    };
    updatePagination(location.href + location.search);
    updateDropdownNavURLsOnLoad();
    updateSmartFiltersCount();

    if (window.rcProps.isSmartFiltersPage) {
        const $originalSearchTerm = $('#original-search-term');
        if ($originalSearchTerm.length) {
            const correctedSearchTerm = $('#smart_search_term').val();
            const originalSearchTerm = $originalSearchTerm.text();
            window.history.replaceState(null, document.title,
              window.location.href.replace('search=' + encodeURIComponent(originalSearchTerm),
                'search=' + correctedSearchTerm));
        }

        $(document).on('openSmartFilters', function() {
           if (getSmartFilters()) {
               updateValidSmartFilters();
           }
        });

        $('#reset-smart-filters').on('click', function () {
            $('.js-smart-filter').prop('disabled', false).prop('checked', false);

            logEngagement(window.location.href, 'smart_filters', 'start over');
            submitSmartFilters();
        });

        $('#submit-smart-filters').on('click', function () {
            logEngagement(window.location.href, 'smart_filters', 'apply filters');
            submitSmartFilters();
        });

        $('#smart-filters-form input').on('change', function() {
            updateValidSmartFilters();
            const $this = $(this);
            logEngagementWithDetails(window.location.href,
              'smart_filter',
              $this.is(':checked') ? 'select' : 'deselect',
              $this.attr('id'));
        });
    }

    function updateValidSmartFilters() {
        const data = getSmartFilters();

        if (data) {
            const ajaxUrl = appendQuery(removeURLParameter(window.location.href, SMART_FILTER_PARAM), data)
              .replace(/.*\?/, `${window.rcProps.smartFiltersCheckHref}?`);
            $.get(ajaxUrl).done((result) => {
                const validFilters = Object.keys(result).reduce((set, filterType) => {
                    let filterNames = result[filterType];

                    for (let filterName of filterNames) {
                        set.add(`${filterType}_${filterName}`);
                    }

                    return set;
                }, new Set());

                const selectedCategories = $('.js-smart-filter:checked').toArray().reduce((set, el) => {
                    set.add($(el).attr('name'));

                    return set;
                }, new Set());

                $('.js-smart-filter').each(function() {
                    const $el = $(this);
                    $el.prop('disabled', !(
                      $el.is(':checked') || validFilters.has($el.attr('id')) || selectedCategories.has($el.attr('name')))
                    );
                });
            });
        } else {
            $('.js-smart-filter').each(function() {
                $(this).prop('disabled', false);
            });
        }
    }
});

window.manageRefineMenuViaAjax = function(){
    manageRefineMenu();
};

export default function manageRefineMenu() {
    const isSearch = isSearchPage();

    $(SELECTORS.checkboxFilter).change(function() {
        loadBrandsURL(this);
    });

    $(SELECTORS.clearFilter).click(function(event) {
        event.preventDefault();
        $('#refine-filters select').each(function() {
            if ($(this).attr('id') === 'newarrivals') {
                return;
            }
            $(this).prop('selectedIndex', -1);
            setCount(this, true);
        });

        var curDep = getQueryParamValues(window.location.href, 'd')[0];
        setFilterOptionSelectedByValue($('#department'), curDep);

        $('#benefits, #benefits_hair, #coverage, #finish, #skin_type, #key_ingredient, ' +
            '#formulation, #frame_type, #lens_detail, #face_shape, #sunglasses_fit').each(
            function() {
                const $this = $(this);
                if ($this.hasClass('select_all')) {  // View All can change based on Java code
                    $this.prop('selectedIndex', 0);
                }
            });

        $(".js-checkbox-filter:not(#in-stock-filter)").prop('checked', false).trigger("change");

        // $(SELECTORS.applyFilter).click();
        loadBrandsURL(this);
    });

    const sortBySelector = SELECTORS.sortBy;
    $(sortBySelector).off().on('change', function(){
        // $(SELECTORS.applyFilter).click();
        loadBrandsURL(this, true);
    });

    $(SELECTORS.catFilter).change(function(){
        // $(SELECTORS.applyFilter).click();
        loadBrandsURL(this);
    });

    $(SELECTORS.departmentFilter).change(function(){
        $('#alldesigners, #allcolors, #allprices, #heel, #length, #sleeve, #rise, #fragrance, #allsizes, #category, #searchcategory, #searchdesigner').prop('selectedIndex', 0);
        if (!isPersonalShop() && !isFavoritePage()) {
            var dep = $(this).val();
            var search = getQueryParamValues(window.location.href, 'search')[0];
            loadSearchFilterOptions(dep, search);
        }
    });

    $(SELECTORS.filterClickable).off().on("click", function(e){
        e.preventDefault();
        loadBrandsURL(this);
    });
    $('#alldesigners, #allcolors, #allprices, #heel, #length, #sleeve, #rise, #fragrance, #allsizes, ' +
        '#benefits, #benefits_hair, #coverage, #finish, #skin_type, #key_ingredient, #formulation, ' +
        '#length_rise, ' +
        '#frame_type, #lens_detail, #face_shape, #sunglasses_fit, #stretch, #condition').change(function(e){
        const $el = $(this);
        const refineValue = $el.val();
        if(refineValue && !refineValue[0] && refineValue.length > 1) {
            $el.find('.select_all').removeAttr('selected').prop("selected", false);
        }
        loadBrandsURL(this, true, true);
    });
    //some filters specifically in search page and new page
    $('#allcategories, #category, #department, #searchcategory, #searchdesigner').change(function(e){
        const $el = $(this);
        let refineValue = $el.val();

        if (window.rcProps.isSmartFiltersPage
          && $el.attr('id') === SELECTORS.departmentFilter.replace('#', '')) {
            let urlParams = getUrlParams(window.location.href, true);
            const url = removeFilterParams(urlParams);
            refineValue = $('input[name="department"]:checked').val();
            window.location.href = url + (url.indexOf("?") > 0 ? "&" : "?") + "d=" + refineValue;
        }

        if(refineValue && !refineValue[0] && refineValue.length > 1) {
            $el.find('.select_all').removeAttr('selected').prop("selected", false);
        }
        loadBrandsURL(this);
        // reset the side panel on department change since there will be a different set of filters (e.g., designers)
        if ($el.attr('id') === 'department' && (isPersonalShop() || isFavoritePage())) {
            $('#done_filters').click();
            resetSidePanel();
        }
    });

    $('#newarrivals').change(function(e){
        location.href = $(this).find('input[name="newDate"]:checked').data('url');
    });

    $('#refine-filters select').on('change', function() {
        setCount(this, false);
    })

    $('#done_filters').click(function(e){
        if ((!isSearch && window.rcProps.sidebarHref)
            || (isSearch && window.rcProps.search.sidebarHref)) {  // URL is changed by loadBrandsURL so just refresh page
            $(SELECTORS.sidebarClose).click();
            $(SELECTORS.sortRefineButton).length && $(SELECTORS.sortRefineButton).attr('aria-expanded', false);
        } else {
            $(SELECTORS.refineButton).click();
        }
    });

    $(SELECTORS.refineButton).on('click', function() {
        if ($(this).hasClass('is-active')) {
            window.logEngagement(window.location.href, REFINE_MENU_MODULE, 'Click');
        }
    });

    $(SELECTORS.sortBy).on('click', function() {
        if (window.rcProps.plpStickyNav === true) {
            if ($(this).parents('.is-scrolled').length > 0) {
                window.logEngagementWithDetails(window.location.href, 'Sort By Dropdown', 'Click', "Plp StickyNav : fixed in scroll");
            } else {
                window.logEngagementWithDetails(window.location.href, 'Sort By Dropdown', 'Click', "Plp StickyNav : initial position");
            }
        } else {
            window.logEngagement(window.location.href, 'Sort By Dropdown', 'Click');
        }
    });

    $(SELECTORS.sortRefineButton).on('click', function() {
        if (window.rcProps.plpStickyNav === true) {
            if ($(this).parents('.is-scrolled').length > 0) {
                window.logEngagementWithDetails(window.location.href, 'Refine Sidebar', 'Click', "Plp StickyNav : fixed in scroll");
            } else {
                window.logEngagementWithDetails(window.location.href, 'Refine Sidebar', 'Click', "Plp StickyNav : initial position");
            }
        } else {
            window.logEngagement(window.location.href, 'Refine Sidebar', 'Click');
        }
    });

    $(SELECTORS.plpNavDropdown).on('click', function () {
        if (window.rcProps.plpStickyNav === true) {
            if ($(this).parents('.is-scrolled').length > 0) {
                window.logEngagementWithDetails(window.location.href, 'Nav Dropdown', 'Click', "Plp StickyNav : fixed in scroll");
            } else {
                window.logEngagementWithDetails(window.location.href, 'Nav Dropdown', 'Click', "Plp StickyNav : initial position");
            }
        } else {
            window.logEngagement(window.location.href, 'Nav Dropdown', 'Click');
        }
    });
}

function setCount(elem, clear) {
    if (clear) {
        $(elem).parent('label').find('.filter__item-count').text('');
        return false;
    }
    const $elem = $(elem); // select
    const $count = $elem.parent('label').find('.filter__item-count');
    const numSelectedOptions = $elem.val().length; // selects values amount - might need
    if (numSelectedOptions > 0) {
        $count.text(`(${numSelectedOptions})`);
    } else {
        $count.text('');
    }
}

function setFilterOptionSelectedByValue(filterElement, value) {
    if(value && filterElement.find('option[value="' + value + '"]').length > 0) {
        filterElement.val(value);
    }
}

function loadSearchFilterOptions(department, search) {
    $.ajax({
        url:"/r/ajax/SearchFiltersOptions.jsp",
        dataType: "json",
        data: {
            "d": department,
            "search": search
        }
    }).done(function(data){
        if(data.success) {
            $('#searchcategory, #searchdesigner').children().remove();
            $.each(data.categories, function(i, optionData){
                $('#searchcategory').append($('<option>').text(optionData.name).attr('value', optionData.value));
            });
            $.each(data.designers, function(i, optionData){
                $('#searchdesigner').append($('<option>').text(optionData.name).attr('value', optionData.value));
            });
        }
    });
}

function getSingleItemOption(element){
    if (element && element.length > 0){
        return element.val();
    } else {
        return '';
    }
}

function getMultiItemOptions(element, dataNameForOption){
    const isSearch = isSearchPage();
    if (element && element.length > 0){
        if ((!isSearch && window.rcProps.sidebarHref)
            || (isSearch && window.rcProps.search.sidebarHref)) {  // Using checkboxes instead of <option> elements
            const checkedValues = [];
            element.find('input[type="checkbox"]:checked').each(function(){
                if (!dataNameForOption || $(this).data('name') === dataNameForOption) {
                    checkedValues.push(this.value);
                }
            });
            return checkedValues;
        } else {
            // Remove empty values (i.e., the "All" value) if there are other values
            // Customer will have to clear all filters or de-select filters to get back the "All" value
            var options = element.val();
            if (options && options.length > 1) {
                var rtn = [];
                for (var i = 0; i < options.length; i++) {
                    if (options[i] !== ''
                        && (!dataNameForOption
                            || element.find(`option[value="${options[i]}"]`).data('name') === dataNameForOption)) {
                        rtn.push(options[i]);
                    }
                }
                options = rtn;
            } else if (dataNameForOption && element.find('option:selected').data('name') !== dataNameForOption) {
                return [];
            }
            return options;
        }
    } else {
        return [''];
    }
}

function getQueryParamValues(url, param) {
    var result = [];
    if(url) {
        var paramsAndValues = url.slice(url.indexOf('?') + 1).split('&');
        for (var i = 0; i < paramsAndValues.length; i++) {
            if(paramsAndValues[i]) {
                var paramAndValue = paramsAndValues[i].split('=');
                if(2 == paramAndValue.length && (param == paramAndValue[0]) && paramAndValue[1]) {
                    // Inverse of $.param, which is used in getFilterParams
                    var value = decodeURIComponent(paramAndValue[1].replace(/\+/g, ' '));
                    result.push(value);
                }
            }
        }
    }
    return result;
}

window.dynamicallyEnableDisableFilters = function (filterMenuList) {
    if(!filterMenuList)
        return -1;
    const isSearch = isSearchPage();
    for(var j=0;j<filterMenuList.length;j++) {
        var filterMenu = filterMenuList[j];
        if(!filterMenu || !filterMenu.idForHTML || !filterMenu.filterMenuList)
            continue;
        var filterId = filterMenu.idForHTML;
        var isSelected = false;
        for(var i=0;i<filterMenu.filterMenuList.length;i++) {
            var filterObj = filterMenu.filterMenuList[i];
            if(!filterObj)
                continue;
            if (filterObj.category === "sustainability") {
                updatePillarNavigation(filterObj);
            } else {
                const option = (!isSearch && window.rcProps.sidebarHref)
                    || (isSearch && window.rcProps.search.sidebarHref) // If the sidebar UI AB test wins rename `option` to `input`
                    ? $(`#${filterId} input[value="${filterObj.value}"]`)
                    : $('#'+filterId+' option[value="'+filterObj.value+'"]');
                if(option.length) {
                    const propToCheck = (!isSearch && window.rcProps.sidebarHref)
                        || (isSearch && window.rcProps.search.sidebarHref)
                        ? 'checked' : 'selected';
                    if(filterObj.disabled && option.prop(propToCheck)) {
                        option.prop(propToCheck, false);
                        option.trigger("change");
                        return;
                    } else {
                        option.prop("disabled", filterObj.disabled);
                        option.prop(propToCheck, filterObj.selected);
                        if(filterObj.selected == true){
                            isSelected = true;
                        }
                    }
                }

                if ((!isSearch && !window.rcProps.sidebarHref)
                    || (isSearch && !window.rcProps.search.sidebarHref)) {
                    if (!isSelected) {
                        var selectAllOption = $('#' + filterId + ' .select_all');
                        if (selectAllOption.length) {
                            selectAllOption.prop('selected', true);
                        }
                    }
                }
            }
        }
    }
}

function updatePillarNavigation(filterObj) {
    if (filterObj.idForHTML) {
        var filter = $('#' + filterObj.idForHTML);
        if (filter) {
            filter.prop('disabled', filterObj.disabled);
            var siblings = filter.siblings('label');
            var label = siblings && siblings.length > 0 ? $(siblings[0]) : null;
            if (label) {
                if (filterObj.disabled) {
                    label.addClass('sustainable__filter--disabled');
                } else {
                    label.removeClass('sustainable__filter--disabled');
                }
            }
        }
    }
}

window.reloadBindJs = function () {
    $(SELECTORS.filterClickable).off().on('click', function(e){
        e.preventDefault();
        loadBrandsURL(this);
    });

    $(SELECTORS.sortBy).off().on('change', function(){
        loadBrandsURL(this);
    });

    if(window.bindHeartItems) {
        window.bindHeartItems();
    }

    if (window.bindPlpSwatchJs) {
        window.bindPlpSwatchJs();
    }
    $('.js-lazy-image').lazy().lazy({
        effect: 'fadeIn',
        effectTime: 300,
        threshold: 900,
     });

    if (typeof window.initColorSwatches == 'function') {
        window.initColorSwatches()
    }
    if (typeof window.loadShopMoreSection == 'function') {
        window.loadShopMoreSection()
    }

    if (typeof window.bindSimilarItemsExpansion == 'function') {
        window.bindSimilarItemsExpansion();
    }

    if (typeof window.loadPagination == 'function') {
        window.loadPagination();
    }

    if (typeof window.favoriteDesignerTrigger == 'function') {
        window.favoriteDesignerTrigger();
    }

    if (typeof window.bindPersonalShop === 'function') {
        window.bindPersonalShop();
    }

    if($('.js-horizontal-scroll').length) {
        $('.js-horizontal-scroll').horizontalScroll();
    }

    if (window.rcProps.revieveEventEnabled) {
        revieveTryOn({
            isPlp: true,
            checkAvailability: true,
        });
    }

    if (window.rcProps.zeligWidgetLoaded) {
        $('.js-zelig-try-on').removeClass('u-hide');
    }

    $('.js-lazy-video').each(function() {
        this.play();
    });

    // loading yotpo star widget
    if (typeof yotpoWidgetsContainer !== 'undefined' ) {
        yotpoWidgetsContainer.initWidgets();
    }

    $('[id$="-fav-select-size"]').each(function () {
        $(this).sizeSelection();
    });
}

function ContentUpdate(pdpUrl, visualNavPageNum, isPagination) {
    var canceled = false;

    const selectedDept = $('input[name="department"]:checked').val()?.toLowerCase();
    const isMenSelected = $('#isMen').val() === 'true'
        || ((isPersonalShop() && window.rcProps?.isMen) || selectedDept === 'mens') // personal shop
        || (isFavoritePage() && window.rcProps?.isMen); // my favorite
    const isKidSelected = $('#isKid').val() === 'true';

    let department = 'Womens';
    let isMen = false;

    if (isMenSelected) {
        department = 'Mens';
        isMen = true;
    } else if (isKidSelected) {
        department = 'Kids';
    }
    const url = pdpUrl + "&d=" + department;
    var data = $.param({
        url: url,
        isMen: isMen,
    });

    this.go = function() {
        if(!visualNavPageNum) {
            visualNavPageNum = 1;
        }
        let $loadVisualNav = $('#loadVisNav')
        if ($loadVisualNav.length && $loadVisualNav.val()==='true' && typeof window.doVisualSearch == 'function') {
            window.doVisualSearch(visualNavPageNum, function (filterMenuList) {
                $('#clear_filters').show();
                dynamicallyEnableDisableFilters(filterMenuList);
                reloadBindJs();
            });
        } else {
            $.ajax({
                url: '/content/products/filtered-plp-contents/',
                data: data,
                dataType: 'json',
                type: 'POST',
                success: function (data) {
                    if (!canceled) {
                        var $plp_product_contents_container = $('#plp-products-contents');
                        var $plp_editorial_cta_contrainer = $('#plp-editorial-cta-wrapper-ajax');
                        var $plp_pagination_container = $('#plp-pagination-wrapper-ajax');
                        var $plp_count = $('#plp-item-count');
                        const $showProductsCount = $("#showing-items-count");
                        const $showPageCount = $("#total_pages");
                        const $js_plp_count = $('.js-plp-item-count');
                        const $logo = window.rcProps.logoId ? $(window.rcProps.logoId) : null;
                        $plp_product_contents_container.html(data.plpMarkup);
                        $plp_editorial_cta_contrainer.html(data.editorialCtaMarkup);
                        if (data.paginationMarkup) {
                            $plp_pagination_container.html(data.paginationMarkup);
                        }
                        if (data.productCount) {
                            // formatted using the same JS snippet as on R Main
                            $plp_count.html(data.productCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                            if ($js_plp_count) {
                                $js_plp_count.html($plp_count.html());
                            }
                        }
                        if (data.pagetCount && $showPageCount) {
                            $showPageCount.html(data.pageCount.toString());
                        }
                        if ($showProductsCount) {
                            const productsCount = $('.js-plp-prod-wrapper').find('li.js-plp-container').length;
                            $showProductsCount.html(productsCount);
                        }
                        if ($logo && $logo.length && data.logoMarkup) {
                            $logo.replaceWith(data.logoMarkup);
                        }
                        if ($('.js-view-more-btn').length > 0) {
                            if (data.pageCount <= 1) {
                                $('.js-view-more-btn').hide();
                            } else {
                                $('.js-view-more-btn').show();
                            }
                        }
                        if(isPagination) {
                            $('html, body').scrollTop(0);
                        }
                        $('#clear_filters').show();
                        dynamicallyEnableDisableFilters(data.filterMenuList);
                        if (data.pillarFilters) {
                            updatePillarNavigations(data.pillarFilters);
                        }
                        reloadBindJs();
                        renderPlpSocialProof($('.js-plp-container').toArray().map((el) => $(el).prop('id')));
                        updatePagination(location.href + location.search);
                        insertPageTrackForMobile(false, null, null, null, false, false, false, true);
                    }
                    else {
                        console.log("cancelled: " + pdpUrl);
                    }
                },
                error: function() {
                    console.log("PLP filters ajax failed");
                    window.location.assign(pdpUrl);
                }
            });
        }


        return this;
    };

    this.cancel = function() {
        canceled = true;
    };
}

//Closure and Currying
var updateContent = (function() {
    var pending = null;
    return function(pdpUrl, visualNavPageNum, isPagination) {
        if (pending) {
            pending.cancel();
            pending = null;
        }
        pending = new ContentUpdate(pdpUrl, visualNavPageNum, isPagination).go();
        return pending;
    };
}());

function getUrlParams(currentUrl, excludeSortBy) {
    let urlParams = {
        path: currentUrl,
        catFilter : $('#category').val(),
        designers: $('#alldesigners').length ? getMultiItemOptions($('#alldesigners')) : ($('#searchdesigner').length ? getSingleItemOption($('#searchdesigner')) : getQueryParamValues(window.location.href, 'designer')),
        sizes: getMultiItemOptions($('#allsizes')),
        colors: getMultiItemOptions($('#allcolors')),
        prices: getMultiItemOptions($('#allprices')),
        heels: getMultiItemOptions($('#heel')),
        lengths: getMultiItemOptions($("#length")),
        sleeves: getMultiItemOptions($("#sleeve")),
        rises: getMultiItemOptions($("#rise")),
        fragrances: getMultiItemOptions($("#fragrance")),
        conditions: getMultiItemOptions($("#condition")),
        featuredCodes: getQueryParamValues(currentUrl, 'featuredCodes'),
        arrivalDate: $('#newarrivals').length > 0 ? $('#newarrivals input[name="newDate"]:checked').val() : '',
        pageNum: parseInt($('#pageNum_param').val()),
        department: window.rcProps.search.sidebarHref ? $('#department input:checked').val() : getSingleItemOption($('#department')),
        searchcategory: getSingleItemOption($('#searchcategory'))
    };

    // combined filter for length and rise
    if ($('#length_rise').length) {
        urlParams.lengths = getMultiItemOptions($('#length_rise'), 'length');
        urlParams.rises = getMultiItemOptions($('#length_rise'), 'rise');
    }

    if (window.rcProps.search.sidebarHref) {
        urlParams.category = getMultiItemOptions($('#allcategories'));
    }

    if (!excludeSortBy) {
        const isSearch = isSearchPage();
        const sortBySelector = $('#sortby option:selected');
        if (sortBySelector.length) {
            urlParams.sortBy = sortBySelector.val();
        }
    }
    $.each(addtionalFilterArray, function(index, value){
        if($('#' + value).length > 0){
            urlParams[value] = getMultiItemOptions($('#' + value));
        }
    });
    const filterInteractions = window.rcProps ? window.rcProps.filters_send_false : {};
    checkboxFilterNames.forEach(function(inputName) {
        urlParams[inputName] = $('input[name="' + inputName + '"]')
            .toArray()
            .filter(el => {
                const $el = $(el);
                if (!$el.is(':checked')){
                    return true;
                }
                if (checkboxFiltersForcedFalseObj[inputName] !== undefined) {
                    if (filterInteractions[inputName]) {
                        return true;
                    } else {
                        // Some checkboxes need `false` to be sent to the server when they are unchecked
                        // (e.g., in_stock) because they persist for the session
                        return 'false';
                    }
                }
            }).map(el => {
                const $el = $(el);
                return $el.is(':checked') ? $el.val() : 'false';
            });
    });
    return urlParams;
}

function isFavoritePage() {
    return window.location.href.indexOf('mr_favorites') > -1;
}

function isPersonalShop() {
    return window.location.href.indexOf('myfav/designers') > -1;
}

function isSearchPage() {
    return window.location.href.indexOf('SearchResult.jsp') > -1;
}

function isNewPage() {
    return $('#newarrivals').length > 0;
}

function isBiBestSellersPage() {
    return window.location.href.indexOf('/content/best-sellers/mobile/') > -1;
}

function loadBrandsURL(elem, resetToPageOne, appendParamsToDropdownNav){
    if (elem === 'undefined')
        return;
    // ab3336 - trigger custom event when a filter is selected
    $(document).trigger("filterSelected");
    var currentUrl = window.location.href;
    const sortByElementTriggeredChange = elem.id === 'sortby';
    if (sortByElementTriggeredChange) {
        currentUrl = removeURLParameter(currentUrl, "featuredCodes");
    } else {
        currentUrl = removeURLParameter(currentUrl, 'sortBy');
    }
    let urlParams = getUrlParams(currentUrl, !sortByElementTriggeredChange);
    let isNew = isNewPage();
    var selectFromCategory = $(elem).closest('div').prop('id') === 'plp_filter_dd';
    // category filters
    if (selectFromCategory) {
        urlParams.path = $(elem).data('caturl');
        resetFilters(urlParams);
    }

    // new arrival dates
    if (isNew && !selectFromCategory) {
        urlParams.path = $('#newarrivals input[name="newDate"]:checked').data('url');
        urlParams.arrivalDate = $('#newarrivals input[name="newDate"]:checked').val();
    }

    // pagination
    var isPagination = false;
    if (elem.id === 'prev_btn') {
        urlParams.pageNum = urlParams.pageNum - 1;
        isPagination = true;
    }
    if (elem.id === 'next_btn') {
        urlParams.pageNum = urlParams.pageNum + 1;
        isPagination = true;
    }

    if($(elem).hasClass("pagination__link")){
        urlParams.pageNum = $(elem).data("pageNo");
        isPagination = true;
    }

    if (resetToPageOne) {
        urlParams.pageNum = 1;
    }

    let isFavorites = isFavoritePage();
    var newURL = '';
    var alreadyParams = urlParams.path && urlParams.path.indexOf("?") > -1;
    //var isPrettyURL = (urlParams.path.indexOf(".jsp") < 0);
    urlParams.path = removeFilterParams(urlParams);
    urlParams.path = removeParam(urlParams, "arrivalDate");
    if (alreadyParams) {
        newURL = urlParams.path + getFilterParams(urlParams);
    } else {
        newURL = urlParams.path + '?' + getFilterParams(urlParams);
    }

    // append arrival date for selected status
    if (isNew)
        newURL = newURL + "&arrivalDate=" + urlParams.arrivalDate;

    let loadVisualNav = $('#loadVisNav');
    if (loadVisualNav.length && loadVisualNav.val() === 'true') {
        newURL = newURL + "&loadVisNav=true";
    }

    //update 'filters' param
    var filtersObj = updateUrlForFiltersParam(newURL);
    const useRefineSidebar = window.rcProps.sidebarHref || window.rcProps.search.sidebarHref;

    if (isBiBestSellersPage()
            // only reloading page if clearing filters for non-sidebar UI (i.e., group A for AB test)
            || (!isPagination && ((!filtersObj.isAddedFilter && !useRefineSidebar) || !$("#plp-products-contents").length)))
    {
        window.location.assign(filtersObj.url);
    } else {
        if (!selectFromCategory && !isPagination && !isNew && appendParamsToDropdownNav) {
            appendFilterParamsToDropdownNav(urlParams, filtersObj);
        }
        //remove hash and update main window url, but not redirect
        removeHash(filtersObj.url);
        updateContent(filtersObj.url, 1, isPagination);
        let filterCount = 0;
        for (let i = 0; i < filterNames.length; i++) {
            const filterNameValue = filterNames[i];
            const filterName = filterNameValue in filterNamesToUrlParamsMap ?
                filterNamesToUrlParamsMap[filterNameValue] :
                filterNameValue;
            if (urlParams[filterName] && urlParams[filterName].length > 0) {
                for (let j = 0; j < urlParams[filterName].length; j++) {
                    if (!urlParams[filterName][j].match(/^\s*$/)) {  // filter out whitespace values
                        filterCount++;
                    }
                }
            }
        }
        filterCount += $('.js-smart-filter:checked').length;
        $('.js-filter-count').text(filterCount > 0 ? '(' + filterCount + ')' : '');
    }

}

function keepFilters(){
    return window.rcProps && window.rcProps.keepRefineFilter;
}

function appendFilterParamsToDropdownNav(urlParams, filtersObj){
    if (!keepFilters() || !filtersObj){
        return;
    }
    $('.js-page-header__nav-list li.ui-list__item a').each(function(){
        let baseUrl = removeURLParameters($(this).attr("href"), filterNames);
        let newUrl = replaceURLParameters(baseUrl, getFilterParams(urlParams));
        newUrl = clearQueryParameters(newUrl, {
            pageNum : true,
            filter: true,
            sortBy: true
        });

        $(this).attr("href", filtersObj.filtersApplied ? replaceURLParameters(newUrl, "filters=" + filtersObj.filtersApplied) : clearQueryParameters(newUrl, {
            "filters": true
        }));
    });
}

function updatePagination(url){
    $('.pagination__list .filters__pagination-item a').each(function(){
        let newUrl = clearQueryParameters(url, {
            pageNum : true
        });
        const page = $(this).data('pageNo');
        const query = 'pageNum=' + page;
        newUrl = newUrl + ((newUrl.indexOf("?") > -1) ? "&" : "?") + query;
        $(this).attr("href", newUrl);
    });
}

function updateDropdownNavURLsOnLoad(){
    if(!keepFilters()){
        return;
    }
    if ($('#clear_filters').css('display') !== 'none' && !isNewPage() && !isSearchPage() && !isFavoritePage()
        && !isPersonalShop()) {
        let currentUrl = window.location.href;
        let urlParams = getUrlParams(currentUrl);
        let filtersObj = updateUrlForFiltersParam(currentUrl);
        appendFilterParamsToDropdownNav(urlParams, filtersObj);
    }
}

function updateUrlForFiltersParam(url) {
    var filtersApplied = '';
    var urlArray = url.split("?");
    if(urlArray.length>1) {
        filtersApplied = getFiltersApplied(urlArray[1]);
    } else {
        return url;
    }
    var filtersNotApplied = {};
    url = removeURLParameter(url, filtersParamName);
    var isAddedFilter = false;
    $.each(filterNames, function (index, value) {
        if(url.indexOf(value+'=') >= 0 || url.indexOf(value+'%5B%5D=') >= 0){
            isAddedFilter = true;
            if (filtersApplied.indexOf(value) < 0) {
                filtersApplied = addFilterApplied(filtersApplied, value);
            }
        } else {
            filtersNotApplied[value] = true;
        }
    });

    for (var filterType in filtersNotApplied){
        filtersApplied = removeFilterApplied(filtersApplied, filterType);
    }

    if (filtersApplied) {
        url = replaceURLParameters(url, filtersParamName + '=' + filtersApplied);
    } else {
        url = clearQueryParameters(url, {filters: ''});
    }

    return {url:url, isAddedFilter:isAddedFilter, filtersApplied: filtersApplied};
}

function removeURLParameters(url, parameterNameList) {
    if (url && parameterNameList.length > 0) {
        parameterNameList.forEach(function (parameterName) {
            url = removeURLParameter(url, parameterName);
            url = removeURLParameter(url, parameterName + "[]");
        });
    }
    return url;
}

function clearQueryParameters(url, params) {
    for (var p in params) {
        url = removeURLParameter(url, p);
        url = removeURLParameter(url, p + "[]");
    }
    return url;
}

function appendQuery(url, query) {
    if ("" == query) {
        return url;
    }
    query = $('<div/>').html(query).text();
    return url + ((url.indexOf("?") > -1) ? "&" : "?") + query;
}

function replaceURLParameters(url, parameterString){
    if (!parameterString)
        return url;

    var parameters = parameterString.split('&');
    var rtn = url;
    var tmp='';
    if (parameters) {
        for (var i=0; i<parameters.length; i++) {
            var p = parameters[i];
            if (p){
                var parameterPair = p.split('=');
                if (parameterPair && parameterPair.length == 2){
                    rtn = removeURLParameter(rtn, parameterPair[0]);
                }
                tmp = appendQuery(tmp, p);
            }
        }

        rtn = safeConcat(rtn, tmp);
    }
    return rtn;
}

function addFilterApplied(filtersAppliedDelimited, filterToAdd){
    if (filtersAppliedDelimited.indexOf(filterToAdd) >= 0)
        return filtersAppliedDelimited;
    return (filtersAppliedDelimited && filtersAppliedDelimited.length > 0 ? filtersAppliedDelimited + filtersAppliedDelimiter : '') +
        filterToAdd;
}

function removeFilterApplied(filtersAppliedDelimited, filterToRemove){
    if (filtersAppliedDelimited.indexOf(filterToRemove) == -1)
        return filtersAppliedDelimited;

    var regex = new RegExp(filterToRemove);
    return filtersAppliedDelimited.replace(regex, '')
        .replace(doubleRegex, filtersAppliedDelimiter)
        .replace(atStartRegex, '')
        .replace(atEndRegex, '');
}

function getFiltersApplied(fullQueryString){
    if (fullQueryString) {
        var qs = fullQueryString.split('&');
        if (qs) {
            for (var i = 0; i < qs.length; ++i) {
                var p = qs[i].split('=', 2);
                if (p[0] === 'filters') {
                    if (p.length == 1) {
                        return '';
                    } else {
                        return decodeURIComponent(p[1].replace(/\+/g, " ")).replace(/^=/, "");
                    }
                }
            }
        }
    }
    return '';
}

function removeHash (url) {
    var scrollV, scrollH, loc = window.location;
    if ("pushState" in history) {
        var urlWithoutHash = url ? url.replace('#', '') : loc.href + loc.search; // Last ditch effort to remove hash
        history.pushState("", document.title, urlWithoutHash);
    }
    else {
        // Prevent scrolling by storing the page's current scroll offset
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;

        loc.hash = "";

        // Restore the scroll offset, should be flicker free
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
    }
}

function resetFilters(urlParams){
    urlParams.designers = [''];
    urlParams.sizes = [''];
    urlParams.colors = [''];
    urlParams.prices = [''];
    urlParams.heels = [''];
    urlParams.lengths = [''];
    urlParams.sleeves = [''];
    urlParams.rises = [''];
    urlParams.fragrances = [''];
    urlParams.conditions = [''];
    urlParams.featuredCodes = [''];
    urlParams.arrivalDate = '';
    urlParams.catFilter = '';
    urlParams.pageNum = 1;
    urlParams.searchcategory = '';
    $.each(addtionalFilterArray, function(index, value){
        if($('#' + value).length > 0){
            urlParams[value] = [''];
        }
    });
    checkboxFilterNames.forEach(function(inputName) {
        urlParams[inputName] = [];
    })
}

function getFilterParams(urlParams){
    let newURL = urlParams.sortBy ? '&sortBy=' + urlParams.sortBy : '';
    var i = 0;
    if (urlParams.designers && urlParams.designers[0]) {
        if (urlParams.designers.length === 1)
            newURL += '&' + $.param({designer: urlParams.designers[0]});
        else
            newURL += '&' + $.param({designer: urlParams.designers}, true);
    }
    if (urlParams.sizes && urlParams.sizes[0]) {
        newURL += '&' + $.param({size: urlParams.sizes}, true);
    }
    if (urlParams.colors && urlParams.colors[0]) {
        newURL += '&' + $.param({color: urlParams.colors}, true);
    }
    if (urlParams.prices && urlParams.prices[0]) {
        newURL += '&' + $.param({price: urlParams.prices}, true);
    }
    if (urlParams.heels && urlParams.heels[0]) {
        newURL += '&' + $.param({heel: urlParams.heels}, true);
    }
    if (urlParams.lengths && urlParams.lengths[0]) {
        newURL += '&' + $.param({length: urlParams.lengths}, true);
    }
    if (urlParams.sleeves && urlParams.sleeves[0]) {
        newURL += '&' + $.param({sleeve: urlParams.sleeves}, true);
    }
    if (urlParams.rises && urlParams.rises[0]) {
        newURL += '&' + $.param({rise: urlParams.rises}, true);
    }
    if (urlParams.fragrances && urlParams.fragrances[0]) {
        newURL += '&' + $.param({fragrance: urlParams.fragrances}, true);
    }
    if (urlParams.conditions && urlParams.conditions[0]) {
        newURL += '&' + $.param({condition: urlParams.conditions}, true);
    }
    $.each(addtionalFilterArray, function(index, value){
       if(urlParams[value] && urlParams[value][0]){
           var tempObj = {};
           tempObj[value] = urlParams[value];
           newURL += '&' + $.param(tempObj);
       }
    });
    checkboxFilterNames.forEach(function(inputName) {
       if (urlParams[inputName]) {
           var obj = {};

           if (urlParams[inputName].length === 1 && typeof urlParams[inputName][0] != 'undefined') {
               obj[inputName] = urlParams[inputName][0];
               newURL += '&' + $.param(obj);
           } else if (urlParams[inputName].length > 1) {
               obj[inputName] = urlParams[inputName];
               newURL += '&' + $.param(obj, true);
           }
       }
    });

    if (urlParams.featuredCodes) {
        for (i = 0; i < urlParams.featuredCodes.length; i++) {
            if(urlParams.featuredCodes[i] != ''){
                newURL = newURL + '&featuredCodes=' + urlParams.featuredCodes[i];
            }
        }
    }
    if(urlParams.catFilter){
        newURL = newURL + '&catFilter=' + urlParams.catFilter;
    }
    if (urlParams.category && urlParams.category[0]) {
        newURL += '&' + $.param({category: urlParams.category}, true);
    }
    if(urlParams.department){
        newURL = newURL + '&d=' + urlParams.department;
    }
    if($('#searchcategory').length && urlParams.searchcategory){
        newURL = newURL + '&s=c&c=' + encodeURIComponent(urlParams.searchcategory);
    }

    if(urlParams.pageNum && urlParams.pageNum > 0) {
        newURL = newURL + '&pageNum=' + urlParams.pageNum;
    }
    return newURL;
}


// Prepare the path string.
// If '?' is not followed by '&' then replace it with with '?&'
function prepareForSafeRemove(path) {

    var rePrepare = /\?(?!&)/;
    path = path.replace(rePrepare, "?&");

    return path;
}

// Remove all occurrences of param and its values
function safeRemoveParam(path, param) {

    var reRemove = new RegExp("[&]+" + param + "=[^&\\b]*", "g");
    path = path.replace(reRemove, '');

    return path
}

// Cleanup the path.
// Replace '?&' with '?
function cleanUpAfterSafeRemove(path) {

    var reCleanup = /\?&+/;
    path = path.replace(reCleanup, '?');

    var reCleanupMultiAmp = new RegExp("&{2,}", "g");
    path = path.replace(reCleanupMultiAmp, '&');

    return path;
}

function removeFilterParams(urlParams) {

    var resultPath = urlParams.path;

    resultPath = prepareForSafeRemove(resultPath);

    resultPath = safeRemoveParam(resultPath, "sortBy");
    resultPath = safeRemoveParam(resultPath, "designer");
    resultPath = safeRemoveParam(resultPath, "designer%5B%5D");
    resultPath = safeRemoveParam(resultPath, "size");
    resultPath = safeRemoveParam(resultPath, "size%5B%5D");
    resultPath = safeRemoveParam(resultPath, "color");
    resultPath = safeRemoveParam(resultPath, "color%5B%5D");
    resultPath = safeRemoveParam(resultPath, "price");
    resultPath = safeRemoveParam(resultPath, "price%5B%5D");
    resultPath = safeRemoveParam(resultPath, "heel");
    resultPath = safeRemoveParam(resultPath, "heel%5B%5D");
    resultPath = safeRemoveParam(resultPath, "length");
    resultPath = safeRemoveParam(resultPath, "length%5B%5D");
    resultPath = safeRemoveParam(resultPath, "sleeve");
    resultPath = safeRemoveParam(resultPath, "sleeve%5B%5D");
    resultPath = safeRemoveParam(resultPath, "rise");
    resultPath = safeRemoveParam(resultPath, "fragrance");
    resultPath = safeRemoveParam(resultPath, "rise%5B%5D");
    resultPath = safeRemoveParam(resultPath, "fragrance%5B%5D");
    resultPath = safeRemoveParam(resultPath, "condition");
    resultPath = safeRemoveParam(resultPath, "condition%5B%5D");
    resultPath = safeRemoveParam(resultPath, "featuredCodes");
    resultPath = safeRemoveParam(resultPath, "catFilter");
    resultPath = safeRemoveParam(resultPath, "pageNum");
    resultPath = safeRemoveParam(resultPath, "category");

    if($('#department').length) {
        // remove d path param only when department filter is applied
        // currently department filter is used on search result page only
        resultPath = safeRemoveParam(resultPath, "d");
    }
    if($('#searchcategory').length) {
        // remove s and c path params only when search category filter is applied
        resultPath = safeRemoveParam(resultPath, "s");
        resultPath = safeRemoveParam(resultPath, "c");
    }

    $.each(addtionalFilterArray, function(index, value){
        resultPath = safeRemoveParam(resultPath, value);
        resultPath = safeRemoveParam(resultPath, value + "%5B%5D");
    });

    checkboxFilterNames.forEach(function(inputName) {
        resultPath = safeRemoveParam(resultPath, inputName);
        resultPath = safeRemoveParam(resultPath, inputName + "%5B%5D");
    });

    resultPath = cleanUpAfterSafeRemove(resultPath);

    return resultPath;
}

function removeParam(urlParams, paramName) {

    var resultPath = urlParams.path;

    resultPath = prepareForSafeRemove(resultPath);

    resultPath = safeRemoveParam(resultPath, paramName);

    resultPath = cleanUpAfterSafeRemove(resultPath);

    return resultPath;
}

function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts= url.split('?');
    if (urlparts.length>=2) {

        var encodedPrefix= encodeURIComponent(parameter)+'=';
        var unencodedPrefix = parameter + '=';
        var pars= urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i= pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(encodedPrefix, 0) !== -1) {
                pars.splice(i, 1);
            }
            else if (pars[i].lastIndexOf(unencodedPrefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}

function safeConcat(url, paramString) {

    var result = '';

    // get rid of the leading '?' or '&' characters
    paramString = removeLeadingChars(paramString);

    var endsWithAmpOrQuestion = /[\?&]$/;

    if(url.indexOf('?') > -1) {
        if (url.match(endsWithAmpOrQuestion)) {
            result = url + paramString;
        } else {
            result = url + '&' + paramString;
        }
    } else {
        result = url + '?' + paramString;
    }

    return result;
}

// Remove the leading '?' or '&' characters
function removeLeadingChars(paramString) {
    // remove RegExp
    var re = /^[?&]+/;
    return paramString.replace(re, '');
}

function submitSmartFilters() {
    $('.js-modal-close').trigger('mousedown');

    const data = getSmartFilters();
    const filtersToClear = {
        pageNum: true,
    };
    filtersToClear[SMART_FILTER_PARAM] = true;
    const windowUrl = appendQuery(clearQueryParameters(window.location.href, filtersToClear), data);
    removeHash(windowUrl);
    updateContent(windowUrl, 1);
    updateSmartFiltersCount();
}

function getSmartFilters() {
    return $('#smart-filters-form')
      .serializeArray()
      .map((filter) => `${SMART_FILTER_PARAM}=${filter.name}${DELIMITER}${filter.value}`)
      .join('&');
}

function updateSmartFiltersCount() {
    const numSelected = $('#smart-filters input:checked').length;
    if (numSelected) {
        $('#smart-filters-count').text(` (${numSelected})`);
    } else {
        $('#smart-filters-count').text("");
    }
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/manage-refine-menu.js